import React from 'react';
import { Skeleton } from 'antd';
import './style.scss';

interface IProps {}

const NUMBER = 1;
const NUMBER_OF_BLOCKS = [NUMBER, NUMBER, NUMBER];

export class SkeletonBenefitsItems extends React.Component<IProps, null> {
  render(): React.ReactNode {
    return (
      <div className="skeleton-benefits-items">
        {NUMBER_OF_BLOCKS.map((item, index) => (
          <div key={`${index}-${item}`} className="skeleton-benefits-items__wrapper">
            <Skeleton
              className="skeleton-benefits-items__img-skeleton"
              active
              title={false}
              paragraph={{ rows: 1 }}
            />
            <Skeleton
              className="skeleton-benefits-items__text-skeleton"
              active
              title={false}
              paragraph={{ rows: 2 }}
            />
            <Skeleton
              className="skeleton-benefits-items__text-skeleton"
              active
              title={false}
              paragraph={{ rows: 3 }}
            />
          </div>
        ))}
      </div>
    );
  }
}
